import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import PricingTableFieldHeaderCell from './PricingTableFieldHeaderCell';

const TableHeader = styled.thead`
  tr {
    background-color: ${(props) => props.columnTitleBackgroundColor || 'rgb(240, 240, 240)'};
    font-size: ${(props) => (props.columnTitleFontSize ? `${props.columnTitleFontSize}px` : 'inherit')};
    color: ${(props) => props.columnTitleFontColor || props.theme?.fontColorPrimary || 'inherit'};
    font-style: ${(props) => props.columnTitleFontStyle || 'normal'};
    font-weight: ${(props) => props.columnTitleFontWeight || 'normal'};
    text-align: ${(props) => props.columnTitleTextAlign || 'left'};
    text-transform: ${(props) => props.columnTitleTextTransform || 'none'};
    text-decoration: ${(props) => props.columnTitleTextDecoration || 'none'};
    padding: ${(props) => (props.columnTitlePadding ? `${props.columnTitlePadding}px` : '8px')};
  }
`;

const PricingTableFieldHeader = ({
  columns,
  canManageColumns = true,
  onMoveColumn,
  onInsertColumn,
  onChangeColumnType,
  onChangeColumnFormat,
  onDeleteColumn,
  onToggleColumnVisibility,
  columnTitleFontSize,
  columnTitleFontColor,
  columnTitleFontStyle,
  columnTitleFontWeight,
  columnTitleTextAlign,
  columnTitleTextTransform,
  columnTitleTextDecoration,
  columnTitleBackgroundColor,
  columnTitlePadding,
  theme
}) => {
  const visibleColumns = columns.filter((column) => !column.hidden);

  return (
    <TableHeader
      columnTitleFontSize={columnTitleFontSize}
      columnTitleFontColor={columnTitleFontColor}
      columnTitleFontStyle={columnTitleFontStyle}
      columnTitleFontWeight={columnTitleFontWeight}
      columnTitleTextAlign={columnTitleTextAlign}
      columnTitleTextTransform={columnTitleTextTransform}
      columnTitleTextDecoration={columnTitleTextDecoration}
      columnTitleBackgroundColor={columnTitleBackgroundColor}
      columnTitlePadding={columnTitlePadding}
      theme={theme}
    >
      <tr>
        {visibleColumns.map((column) => {
          // Find the original column index for proper data handling
          const columnIndex = columns.findIndex((col) => col._id === column._id);
          const isLastColumn = columnIndex === columns.length - 1;

          return (
            <PricingTableFieldHeaderCell
              key={column._id}
              column={column}
              columnIndex={columnIndex}
              totalColumns={columns.length}
              canManageColumns={canManageColumns}
              onMoveColumn={onMoveColumn}
              onInsertColumn={onInsertColumn}
              onChangeColumnType={onChangeColumnType}
              onChangeColumnFormat={onChangeColumnFormat}
              onDeleteColumn={onDeleteColumn}
              onToggleColumnVisibility={onToggleColumnVisibility}
              theme={theme}
              isLastColumn={isLastColumn}
            />
          );
        })}
      </tr>
    </TableHeader>
  );
};

export default PricingTableFieldHeader;

PricingTableFieldHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    hidden: PropTypes.bool
  })).isRequired,
  canManageColumns: PropTypes.bool,
  onMoveColumn: PropTypes.func,
  onInsertColumn: PropTypes.func,
  onChangeColumnType: PropTypes.func,
  onChangeColumnFormat: PropTypes.func,
  onDeleteColumn: PropTypes.func,
  onToggleColumnVisibility: PropTypes.func,
  columnTitleFontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  columnTitleFontColor: PropTypes.string,
  columnTitleFontStyle: PropTypes.string,
  columnTitleFontWeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  columnTitleTextAlign: PropTypes.string,
  columnTitleTextTransform: PropTypes.string,
  columnTitleTextDecoration: PropTypes.string,
  columnTitleBackgroundColor: PropTypes.string,
  columnTitlePadding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  theme: PropTypes.object
};

